module.exports = "<svg viewBox=\"0 0 20 20\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M15 12l-5-5-5 5z\" fill=\"#212B35\"></path></svg>"


//////////////////
// WEBPACK FOOTER
// ./src/resources/caret-up.svg
// module id = 304
// module chunks = 0